(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.searchModal = this.header.querySelector('details-modal.header__search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    isSearchOpen() {
      return (this.predictiveSearch && this.predictiveSearch.isOpen) ||
             (this.searchModal && this.searchModal.isOpen());
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.isSearchOpen()) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.isSearchOpen()) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function needsRatioFromVideo(video) {
      var section = video.closest('[data-adapt-height="true"]');
      if (!section) return null;
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var flag = isMobile ? section.dataset.ratioMobileFromVideo : section.dataset.ratioDesktopFromVideo;
      return flag === 'true' ? section : null;
    }

    function initHeroVideo(video) {
      if (video.dataset.heroInit) return;
      video.dataset.heroInit = '1';

      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var src = (isMobile && video.dataset.srcMobile) || video.dataset.srcDesktop;
      if (!src) return;

      // No poster for this screen size: size the banner to the video's real shape,
      // exactly like the original section did. Adding a poster removes this step.
      var ratioSection = needsRatioFromVideo(video);
      if (ratioSection) {
        video.addEventListener(
          'loadedmetadata',
          function () {
            if (video.videoWidth && video.videoHeight) {
              ratioSection.style.aspectRatio = video.videoWidth + ' / ' + video.videoHeight;
            }
          },
          { once: true }
        );
      }

      // Respect users who asked for less data or less motion: no autoplay.
      var conn = navigator.connection;
      var skipPlayback =
        (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (skipPlayback) {
        if (ratioSection) {
          // Still read the size (a few KB) so the banner has the right shape.
          video.preload = 'metadata';
          video.src = src;
        }
        return;
      }

      video.addEventListener(
        'playing',
        function () {
          video.classList.add('is-playing');
        },
        { once: true }
      );
      video.src = src;
      var playPromise = video.play();
      if (playPromise !== undefined) playPromise.catch(function () {});
    }

    function initAll(root, onlyRatioVideos) {
      (root || document).querySelectorAll('.hero-video__video').forEach(function (video) {
        if (onlyRatioVideos && !needsRatioFromVideo(video)) return;
        initHeroVideo(video);
      });
    }

    // Videos without a poster start right away (otherwise the banner would sit at the
    // wrong height). Videos with a poster wait until the page has fully loaded.
    initAll(document, true);

    function start() {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(function () { initAll(); }, { timeout: 2000 });
      } else {
        setTimeout(initAll, 200);
      }
    }

    if (document.readyState === 'complete') {
      start();
    } else {
      window.addEventListener('load', start, { once: true });
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
